import { QueryKeysEnum } from '@/enums';
import { QcAlertOwnerEntity, UpsertQcAlertOwnersPayload } from '@/types';
import APIService from './axios.service';
import { BaseService } from './base.service';

class QcAlertOwnerService extends BaseService<
  'qcAlertOwner',
  QcAlertOwnerEntity
> {
  constructor() {
    super(QueryKeysEnum.QC_ALERT_OWNER);
  }

  upsert = (
    payload: UpsertQcAlertOwnersPayload,
  ): Promise<QcAlertOwnerEntity[]> => {
    return APIService.patch(this.path, payload);
  };
}

export const qcAlertOwnerService = new QcAlertOwnerService();
